import { Cam } from "onvif";
import https from "https";
import { parseSOAPString  } from "onvif/lib/utils";

class OnvifCam extends Cam {
  // node_modules/onvif/lib/cam.js の HTTP-POST処理をオーバーライド.
  // HTTPS通信でリクエストするように変更.

  _request = function(options, callback) {
    if (typeof callback !== 'function') {
      throw new Error('`callback` must be a function');
    }
    var _this = this;
    var callbackExecuted = false;
    var reqOptions = options.url || {
      hostname: this.hostname
      , port: this.port
      , agent: this.agent //Supports things like https://www.npmjs.com/package/proxy-agent which provide SOCKS5 and other connections
      , path: options.service
        ? (this.uri[options.service] ? this.uri[options.service].path : options.service)
        : this.path
      , timeout: this.timeout
    };
    reqOptions.headers = {
      'Content-Type': 'application/soap+xml'
      , 'Content-Length': Buffer.byteLength(options.body, 'utf8')//options.body.length chinese will be wrong here
      , charset: 'utf-8'
    };

    reqOptions.method = 'POST';
    var req = https.request(reqOptions, function(res) {
      var bufs = [], length = 0;
      res.on('data', function(chunk) {
        bufs.push(chunk);
        length += chunk.length;
      });
      res.on('end', function() {
        if (callbackExecuted === true) {
          return;
        }
        callbackExecuted = true;
        var xml = Buffer.concat(bufs, length).toString('utf8');
        /**
         * Indicates raw xml response from device.
         * @event Cam#rawResponse
         * @type {string}
         */
        _this.emit('rawResponse', xml);
        parseSOAPString(xml, callback);
      });
    });

    req.setTimeout(this.timeout, function() {
      if (callbackExecuted === true) {
        return;
      } else {
        callbackExecuted = true;
      }
      callback(new Error('Network timeout'));
      req.abort();
    });

    req.on('error', function(err) {
      if (callbackExecuted === true) {
        return;
      }
      callbackExecuted = true;
      /* address, port number or IPCam error */
      if (err.code === 'ECONNREFUSED' && err.errno === 'ECONNREFUSED' && err.syscall === 'connect') {
        callback(err);
        /* network error */
      } else if (err.code === 'ECONNRESET' && err.errno === 'ECONNRESET' && err.syscall === 'read') {
        callback(err);
      } else {
        callback(err);
      }
    });
    /**
     * Indicates raw xml request to device.
     * @event Cam#rawRequest
     * @type {Object}
     */
    this.emit('rawRequest', options.body);
    req.write(options.body);
    req.end();
  };
}
export { OnvifCam };
